import { Button } from "antd";
import clsx from "clsx";
import "./styles.css";

export const StyledButton = ({
  children,
  disabled = false,
  onClick = () => {},
  className = "styled-button",
  ...props
}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        !disabled && "styled-button",
        disabled && "disabled-button",
        className
      )}
      {...props}
    >
      <p className="styled-button-text"> {children}</p>
    </Button>
  );
};
